import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { X } from "lucide-react";

const FilterSelect = ({ label, value, onChange, options, testid, placeholder }) => (
  <div className="space-y-1.5">
    <Label className="text-[11px] uppercase tracking-wider text-muted-foreground font-bold">{label}</Label>
    <Select value={value || "any"} onValueChange={(v) => onChange(v === "any" ? "" : v)}>
      <SelectTrigger data-testid={testid} className="bg-[#0A0A0A] border-border rounded-sm h-9 text-sm focus:ring-blaze">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="bg-[#141414] border-border">
        <SelectItem value="any">Any</SelectItem>
        {options.map((o) => {
          const val = typeof o === "object" ? o.value : o;
          const lbl = typeof o === "object" ? o.label : o;
          return <SelectItem key={val} value={val} className="spec-block text-sm">{lbl}</SelectItem>;
        })}
      </SelectContent>
    </Select>
  </div>
);

export const FitmentFilters = ({ constants, filters, setFilters, onApply, onClear, onSave }) => {
  const set = (k) => (v) => setFilters((f) => ({ ...f, [k]: v }));
  if (!constants) return null;

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <h3 className="font-heading font-800 uppercase tracking-tight text-sm">Fitment Filters</h3>
        <button data-testid="clear-filters-btn" onClick={onClear} className="text-[11px] text-blaze hover:underline flex items-center gap-0.5">
          <X className="w-3 h-3" /> Clear
        </button>
      </div>

      <FilterSelect label="Category" value={filters.category} onChange={set("category")} options={constants.categories} testid="filter-category" placeholder="Any" />
      <FilterSelect label="Bolt Pattern" value={filters.bolt_pattern} onChange={set("bolt_pattern")} options={constants.bolt_patterns} testid="filter-bolt-pattern" placeholder="Any" />

      <div className="grid grid-cols-2 gap-3">
        <FilterSelect label="Diameter" value={filters.diameter} onChange={set("diameter")} options={constants.diameters} testid="filter-diameter" placeholder="in" />
        <FilterSelect label="Width" value={filters.width} onChange={set("width")} options={constants.widths} testid="filter-width" placeholder="in" />
      </div>

      <div className="grid grid-cols-2 gap-3">
        <FilterSelect label="Offset (ET)" value={filters.offset} onChange={set("offset")} options={constants.offsets} testid="filter-offset" placeholder="mm" />
        <FilterSelect label="Condition" value={filters.condition} onChange={set("condition")} options={constants.conditions} testid="filter-condition" placeholder="Any" />
      </div>

      <FilterSelect label="Tire Size" value={filters.tire_size} onChange={set("tire_size")} options={constants.tire_sizes} testid="filter-tire-size" placeholder="Any" />
      <FilterSelect label="Fulfillment" value={filters.fulfillment} onChange={set("fulfillment")} options={constants.fulfillment} testid="filter-fulfillment" placeholder="Any" />

      <div className="space-y-1.5">
        <Label className="text-[11px] uppercase tracking-wider text-muted-foreground font-bold">Location</Label>
        <Input data-testid="filter-location" value={filters.location || ""} onChange={(e) => set("location")(e.target.value)} placeholder="City or state" className="bg-[#0A0A0A] border-border rounded-sm h-9 text-sm" />
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label className="text-[11px] uppercase tracking-wider text-muted-foreground font-bold">Min $</Label>
          <Input data-testid="filter-min-price" type="number" value={filters.min_price || ""} onChange={(e) => set("min_price")(e.target.value)} className="bg-[#0A0A0A] border-border rounded-sm h-9 text-sm spec-block" />
        </div>
        <div className="space-y-1.5">
          <Label className="text-[11px] uppercase tracking-wider text-muted-foreground font-bold">Max $</Label>
          <Input data-testid="filter-max-price" type="number" value={filters.max_price || ""} onChange={(e) => set("max_price")(e.target.value)} className="bg-[#0A0A0A] border-border rounded-sm h-9 text-sm spec-block" />
        </div>
      </div>

      <Button data-testid="apply-filters-btn" onClick={onApply} className="w-full bg-blaze hover:bg-blaze-hover text-white rounded-sm font-bold">Apply Filters</Button>
      {onSave && (
        <Button data-testid="save-search-btn" onClick={onSave} variant="outline" className="w-full border-border bg-transparent hover:bg-secondary rounded-sm text-sm">Save this search</Button>
      )}
    </div>
  );
};
